interface PhantomLaunchFailureWatchdogOptions {
  isVisible: () => boolean
  delayMs: number
}

export class PhantomLaunchFailureWatchdog {
  private readonly options: PhantomLaunchFailureWatchdogOptions
  private timer: ReturnType<typeof setTimeout> | null = null
  private attempt = 0
  private disposed = false

  constructor(options: PhantomLaunchFailureWatchdogOptions) {
    this.options = options
  }

  arm(onFailure: () => void): void {
    if (this.disposed) return
    this.clear()
    const attempt = ++this.attempt
    this.timer = setTimeout(() => {
      this.timer = null
      if (this.disposed || attempt !== this.attempt || !this.options.isVisible()) return
      onFailure()
    }, this.options.delayMs)
  }

  clear(): void {
    this.attempt += 1
    if (this.timer !== null) clearTimeout(this.timer)
    this.timer = null
  }

  dispose(): void {
    if (this.disposed) return
    this.clear()
    this.disposed = true
  }
}
